/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20.6",
  r: "20",
  fill: "#D8D8D8"
}), /*#__PURE__*/React.createElement("mask", {
  x: "0",
  y: "0.6",
  width: "40",
  height: "43",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20.6",
  r: "20",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.285)"
}, /*#__PURE__*/React.createElement("mask", {
  x: "0",
  y: "0.9",
  width: "40",
  height: "40",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40,20.9v-20H0v40h40V20.9z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "m40 20.9c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20",
  fill: "#E96A09"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .272)"
}, /*#__PURE__*/React.createElement("mask", {
  x: "0",
  y: "0.9",
  width: "40",
  height: "39.5",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.9 40.4c-11-0.1-19.9-8.9-19.9-19.8s9-19.7 20-19.7l20 19.7c0 10.9-8.9 19.7-19.9 19.7l-0.2 0.1z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40,20.6c0,10.9-9,19.7-20,19.7S0,31.5,0,20.6S9,0.9,20,0.9S40,9.7,40,20.6",
  fill: "#E96A09"
})), /*#__PURE__*/React.createElement("path", {
  d: "m28.6 34.9l0.2-0.2v0.2h-0.2",
  fill: "#C9C8C8"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.111 16.71)"
}, /*#__PURE__*/React.createElement("mask", {
  x: "0.4",
  y: "0.7",
  width: "33.5",
  height: "26.2",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0.4 18.7c3.7 3.4 8.5 5.2 13.5 5.2 11 0 20-8.8 20-19.7l-3.5-3.5h-30v18z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "m33.9 7.3v-1l-5.5-5.7-20.2 6.4-7.8 4.3 15.9 15.7c9.9-1.2 17.6-9.6 17.6-19.7",
  fill: "#BF4218"
})), /*#__PURE__*/React.createElement("path", {
  d: "m34 27.6h-8.1c-0.7 0-1.3-0.6-1.3-1.3v-11.6c0-0.7 0.6-1.3 1.3-1.3h8.1c0.7 0 1.3 0.6 1.3 1.3v11.6c0.1 0.7-0.5 1.3-1.3 1.3",
  fill: "#E7F5FD"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.7 14.6v10.4c0 0.4-0.3 0.6-0.6 0.6h-8.2c-0.4 0-0.6-0.3-0.6-0.6v-10.4c0-0.4 0.3-0.6 0.6-0.6h8.2c0.3 0 0.6 0.3 0.6 0.6",
  fill: "#BBD2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.8 26.7c0 0.3-0.2 0.5-0.5 0.5s-0.5-0.2-0.5-0.5 0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5",
  fill: "#747473"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.7 14.6v10.4c0 0.4-0.2 0.6-0.5 0.6h-4.3v-11.6h4.3c0.3 0 0.5 0.3 0.5 0.6",
  fill: "#A5C1D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.9 23.9h-16.7v-8.5c0-0.4 0.3-0.8 0.8-0.8h15.1c0.4 0 0.8 0.3 0.8 0.8v8.5z",
  fill: "#E7F5FD"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.3 15.4v7.9h-15.5v-7.9c0-0.1 0.1-0.2 0.2-0.2h15.1c0.1 0.1 0.2 0.1 0.2 0.2",
  fill: "#BBD2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.3 27.1h-19.5l1.5-3.2h16.6l1.4 3.2z",
  fill: "#020202"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.3,26L7,24.3h13.1l0.6,1.7H6.3z",
  fill: "#47555F"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.3 28.1h-17.5c-0.6 0-1.1-0.5-1.1-1h19.6c0 0.5-0.4 1-1 1",
  fill: "#E2EBF8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.3 15.4v7.9h-7.8v-8h7.6c0.1 0 0.2 0 0.2 0.1",
  fill: "#A5C1D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.5 30.8h-7c-1.2 0-2.1-0.9-2.1-2.1v-16.4c0-1.2 0.9-2.1 2.1-2.1h7c1.2 0 2.1 0.9 2.1 2.1v16.4c0 1.1-0.9 2.1-2.1 2.1",
  fill: "#47555F"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.6 12.2v14.5c0 0.6-0.5 1-1 1h-7.1c-0.6 0-1-0.4-1-1v-14.5c0-0.6 0.5-1 1-1h7.1c0.5 0 1 0.5 1 1",
  fill: "#BBD2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.8 29.1c0 0.5-0.4 0.9-0.9 0.9s-0.9-0.4-0.9-0.9 0.4-0.9 0.9-0.9c0.5 0.1 0.9 0.5 0.9 0.9",
  fill: "#747473"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.6 12.2v14.5c0 0.6-0.5 1-1 1h-3.7v-16.5h3.7c0.5 0 1 0.5 1 1",
  fill: "#A5C1D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.9 24.2c0 0.2-0.2 0.5-0.5 0.5h-6.6c-0.3 0-0.5-0.2-0.5-0.5v-5.3c0-0.3 0.2-0.5 0.5-0.5h6.6c0.3 0 0.5 0.2 0.5 0.5v5.3z",
  fill: "#FFD400"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.2 18.4v-1c0-1.1 0.9-1.9 2-1.9h0.1c1.1 0 2 0.9 2 1.9v1h0.9v-1c0-1.6-1.3-2.8-2.9-2.8h-0.1c-1.6 0-2.9 1.3-2.9 2.8v1h0.9z",
  fill: "#F3F2F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.2 21c0-0.6-0.5-1-1-1-0.6 0-1 0.5-1 1 0 0.4 0.3 0.8 0.7 1v1.4h0.7v-1.4c0.3-0.2 0.6-0.6 0.6-1",
  fill: "#E18B07"
})), 'RobberyTheft', {
  viewBox: '0 0 40 40'
});